import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=899dc40e&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=js&"
export * from "./PromoCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=899dc40e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899dc40e",
  null
  
)

export default component.exports